import React from 'react';
import { Grid } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { CurrencyInputField, ProductGroupSelectField } from '@occc-app/design-system';

export const SpendBonusConfiguration: React.FC = () => {
  return (
    <>
      <Typography variant='subtitle1' paragraph>
        When They Spend
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <CurrencyInputField name='spendBonus.accumulationThreshold' label='Money Amount' />
        </Grid>
        <Grid item xs={9}>
          <ProductGroupSelectField
            inputProps={{
              margin: 'none',
            }}
            name='spendBonus.ineligibleProductGroups'
            label='Excluded Product groups'
          />
        </Grid>
      </Grid>
    </>
  );
};
